import { useQuery, useInfiniteQuery, useMutation } from "@tanstack/react-query";

import { getPartnerReviewList, getPartnerReviewDetail, deleteReview } from "@src/api/review/review";
import { IReqPartnerReviewListParams, IReqPartnerReviewDetailParams } from "@src/api/review/types";

import { invalidateQueriesCurrentTab } from "./utils";

const reviewQuery = {
  // 업체 리뷰 목록 가져오기
  useGetInfinityPartnerReviewList: (params: IReqPartnerReviewListParams) => {
    return useInfiniteQuery({
      queryKey: ["partner-review-list", params],
      queryFn: ({ pageParam }) => getPartnerReviewList({ ...params, fetchStart: pageParam }),
      initialPageParam: params.fetchStart,
      getNextPageParam: (lastPage) => {
        return lastPage.hasNextPage ? lastPage.nextFetchStart : undefined;
      },
    });
  },
  // 업체 리뷰 상세 가져오기
  useGetPartnerReviewDetail: (params: IReqPartnerReviewDetailParams) => {
    return useQuery({
      queryKey: ["partner-review-detail", params],
      queryFn: () => getPartnerReviewDetail(params),
    });
  },
  // 리뷰 삭제
  useDeleteReview: () => {
    const result = useMutation({
      mutationFn: (data: { reviewId: number; logUuid: string }) =>
        deleteReview(data.reviewId, data.logUuid),
      onSuccess: () => invalidateQueriesCurrentTab(["myReviews"]),
    });
    return {
      isDeleteReviewPending: result.isPending,
      mutateDeleteReview: result.mutate,
    };
  },
};

export default reviewQuery;
